import { render, staticRenderFns } from "./cambiarcontraseña.vue?vue&type=template&id=337e3956"
import script from "./cambiarcontraseña.vue?vue&type=script&lang=js"
export * from "./cambiarcontraseña.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports